import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MsGraphApiModule } from '@content-platform/web-angular-administration-shared-data-access-ms-graph-api';
import {
  DisplayNamePipe,
  UserProfilePipe,
  ObjToArrayPipe,
  SearchPipe,
  SortPipe,
  PhoneNumberPipe,
  TruncatePipe,
  FilterWithPipe,
  MinutesSecondsPipe,
  SortByRelevancePipe,
  HighlightPipe,
  FileNamePipe,
  MillisecHhmmssPipe,
  CommasPipe,
  PixelsPipe,
  MonthDayYearPipe,
  LocalTimePipe,
  FormatBytesPipe,
  FirstThenLastNamePipe,
  WithLoadingPipe,
  DynamicSearchFilterPipe,
  SortByOrderPipe
} from './pipes';

const pipes = [
  DisplayNamePipe,
  UserProfilePipe,
  ObjToArrayPipe,
  SearchPipe,
  SortPipe,
  PhoneNumberPipe,
  TruncatePipe,
  FilterWithPipe,
  MinutesSecondsPipe,
  SortByRelevancePipe,
  HighlightPipe,
  FileNamePipe,
  MillisecHhmmssPipe,
  CommasPipe,
  PixelsPipe,
  FileNamePipe,
  MonthDayYearPipe,
  LocalTimePipe,
  FormatBytesPipe,
  FirstThenLastNamePipe,
  WithLoadingPipe,
  DynamicSearchFilterPipe,
  SortByOrderPipe
];

@NgModule({
  imports: [CommonModule, MsGraphApiModule],
  declarations: [...pipes, DynamicSearchFilterPipe],
  exports: [...pipes]
})
export class PipesModule {}
